// extracted by mini-css-extract-plugin
export default {"navbar":"Navbar_navbar__AHaSr","navbar__button":"Navbar_navbar__button__clXF+","navbar__profile-icon":"Navbar_navbar__profile-icon__BKzo-"};